<template>
	<div id="odometerContainer">
		<div v-for="(bottom, index) in odometer_digits" :key=index class="OdometerSort">
			<div id="odometer">
				<div id="odometerDigitsDiv">
					<div class="odometer_digit" :style="{top: bottom}">
                        9 <br/> 
                        8 <br/>
                        7 <br/>
                        6 <br/> 
                        5 <br/> 
                        4 <br/> 
                        3 <br/> 
                        2 <br/> 
                        1 <br/> 
                        0
                    </div>

					<div class="odometer_digit_background full_width odometer_top" style="top: 20%; height: 32%;    ">
                        <p></p>
                    </div>
                    <div class="odometer_digit_background full_width odometer_top" style="top: 27.5%; height: 16%;  ">
                        <p></p>
                    </div>
                    <div class="odometer_digit_background full_width odometer_top" style="top: 32.5%; height: 6%;  ">
                        <p></p>
                    </div>
                    <div class="odometer_digit_background full_height odometer_top" style="right: 0%; width: 6%; ">
                        <p></p>
                    </div>
                    <div class="odometer_digit_background full_height odometer_bottom" style="left: 0%; width: 4%; ">
                        <p></p>
                    </div>
                    <div class="odometer_digit_background full_width odometer_bottom" style="top: 0%; height: 14%;  ">
                        <p></p>
                    </div>
                    <div class="odometer_digit_background full_width odometer_bottom" style="bottom: 0%; height: 25%;  ">
                        <p></p>
                    </div>
                    <div class="odometer_digit_background full_width odometer_bottom" style="bottom: 0%; height: 8%;   ">
                        <p></p>
                    </div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        props: [
            'value', 
            'places'
        ],
        computed: {
            odometer_digits () {
                var odometerDigits = [];
                var valueString = this.value.toString();
                var digitHeightFactor = this.$store.getters.isMobile ? (this.$store.getters.isTablet ? 4 : 8) : 2;

                for(var d = 0; d < this.places; d++) {
                    var digit= 0;
                    var numLeadingZeros = this.places - valueString.length;

                    if(d >= numLeadingZeros) {
                        digit = valueString[(d - numLeadingZeros)];
                    }

                    var digitHeight = (window.innerWidth * 0.01 * digitHeightFactor);
                    var rolodexHeight = (10 *  (digitHeight));
                    var digitHeightDif = ((parseInt(digit) + 1) * (rolodexHeight / 10));

                    let adjustmentRatio = (window.innerHeight < window.innerWidth) ? 
                                            ((window.innerHeight / window.innerWidth) > .5 ? (1 - (window.innerHeight / window.innerWidth)) : (window.innerHeight / window.innerWidth)) 
                                            : ((window.innerWidth / window.innerHeight) > .5 ? (1 - (window.innerWidth / window.innerHeight)) : (window.innerWidth / window.innerHeight));

                    odometerDigits.push(-((rolodexHeight) - (digitHeightDif + (4 - (parseInt(digit) * adjustmentRatio)))) + 'px');
                }

                return odometerDigits;
            }
        }
    }
</script>

<style scoped>
    .odometer_digit {
        position: absolute;
        height: inherit;
        width: inherit;
        padding: 0px;
        font-size: calc(var(--vw) * 2); 
        line-height: calc(var(--vw) * 2); /*calc(var(--vh) * (4/3) * 4);*/
        background: black;
        text-align: center;
        font-family: sans-serif; /*Consolas, Menlo, Monaco, "Lucida Console", "Liberation Mono", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Courier New", monospace; /*"Courier New", Courier, monospace;*/
        font-weight: 900;
        transition: 1s top;
    }

    .inmobile .odometer_digit {
        font-size: calc(var(--vw) * 8);
        line-height: calc(var(--vw) * 8);
    }

    .inmobile.tabletstyle .odometer_digit {
        font-size: calc(var(--vw) * 4);
        line-height: calc(var(--vw) * 4);
    }

    .odometer_digit_background_wraper {
        position: absolute;
        top: 0px;
        left: 0px;
    }

    .odometer_digit_background {
        position: absolute;
    }

    .odometer_digit_background.full_width {
        width: 100%;
        opacity: 0.25;  
        left: 0px;
    }

    .odometer_digit_background.full_width.odometer_top {
        background: white;
    }

    .odometer_digit_background.full_width.odometer_bottom {
        background: black;
    }

    .odometer_digit_background.full_height {
        height: 100%;
        opacity: 0.5; 
        top: 0px;
    }

    .odometer_digit_background.full_height.odometer_top {
        background: black;
    }

    .odometer_digit_background.full_height.odometer_bottom {
        background: white;
    }

    #odometerContainer {
        width: inherit;
        display: flex;
        justify-content: center;
        align-items: center; 
    }

    .inmobile #odometerContainer {
        margin: 0;
        height: unset;
    }

    #odometer {
        text-align: left;
        color: white;
    }

    #odometerDigitsDiv {
        position: relative; 
        float: left; 
        overflow: hidden; 
        height: calc(var(--vw) * 2); /*calc(var(--vh) * (4/3) * 4);*/
        width: calc(var(--vw) * 1.5); /*calc(var(--vh) * (4/3) * 3); */
        background-color: #12151b;
    }

    .inmobile #odometerDigitsDiv {
        height: calc(var(--vw) * 8);
        width: calc(var(--vw) * 6);
    }

    .inmobile.tabletstyle #odometerDigitsDiv {
        height: calc(var(--vw) * 4);
        width: calc(var(--vw) * 3);
    }
</style>
